import React from "react";
import { ImageSlot } from "./ImageSlot";

const BrandCard = ({ logo, alt, description, testId }) => (
  <div
    className="bg-misty-surface border border-white/5 p-8 sm:p-10 flex flex-col gap-6 transition-all duration-300 hover:border-misty-steel/40 group"
    data-testid={testId}
  >
    <div className="h-24 sm:h-32 lg:h-36 flex items-center">
      <img
        src={logo}
        alt={alt}
        className="h-full w-auto max-w-full object-contain object-left"
        data-testid={`${testId}-logo`}
      />
    </div>
    <div className="w-10 h-px bg-misty-steel/60" />
    <p className="text-misty-muted leading-relaxed font-sans text-sm sm:text-base">
      {description}
    </p>
  </div>
);

const WorldMap = () => null;

export const About = () => {
  return (
    <section
      id="about"
      className="relative py-16 sm:py-20 px-6 md:px-12"
      data-testid="about-section"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col gap-10">
        <div className="flex flex-col gap-4">
          <p className="text-misty-steel text-[10px] sm:text-xs tracking-[0.5em] uppercase font-sans">
            Who We Are
          </p>
          <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl text-misty-text tracking-wide leading-[0.95]">
            Our Brands
          </h2>
          <div className="w-16 h-px bg-misty-steel/60 mt-2" />
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-12 gap-y-4 mt-2">
            <p className="text-misty-muted leading-relaxed text-base sm:text-lg">
              Misty Distribution partners with leading global brands to deliver
              premium vaping devices engineered for performance, longevity, and
              flavour.
            </p>
            <p className="text-misty-muted leading-relaxed text-base sm:text-lg">
              Misty Distribution are the exclusive distributors of{" "}
              <span className="text-misty-text">Gold Bar</span> and{" "}
              <span className="text-misty-text">Titan</span> vapes in South
              Africa.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <BrandCard
            logo="https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/yh3l55gm_GB-LOGO_3.png"
            alt="Gold Bar"
            testId="brand-card-goldbar"
            description="Gold Bar is a premium disposable vape brand renowned for its sleek design, satisfying flavour profiles, and consistent performance. From the compact 600-puff device perfect for beginners and casual vapers, to the high-capacity 247 series delivering up to 12 000 puffs, Gold Bar combines elegance with convenience. Each device is crafted to deliver an exceptional experience straight out of the box."
          />
          <BrandCard
            logo="https://customer-assets.emergentagent.com/job_vape-distribution-za/artifacts/tmkjc7g1_TITAN-LOGO_4.png"
            alt="Titan Pro"
            testId="brand-card-titanpro"
            description="Titan Pro is engineered for vapers who demand more. With an impressive capacity of up to 15 000 puffs and a replaceable pod system, the Titan Pro offers unmatched versatility and long-lasting performance. Its sleek all-in-one form factor paired with USB-C recharging makes it an ideal everyday companion. The Titan Pro's interchangeable pods allow users to switch between an extensive range of flavours on a single device."
          />
        </div>
      </div>
    </section>
  );
};
